import { primary } from '@/theme/colors';

export const Drawer = {
  position: 'fixed' as const,
  top: 0,
  right: 0,
  width: '50%',
  height: '100%',
  background: 'white',
  boxShadow: '-3px 0 15px rgba(0,0,0,0.5)',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column' as const,
  overflowY: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
};

export const TitleBox = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '30px 10px 10px',
  margin: '60px 20px 10px 20px',
};

export const tickStyles = {
  color: primary.gray,
  textAnchor: 'middle',
  fontFamily: 'Roboto',
  fontSize: '1.4rem',
};
